import { render, staticRenderFns } from "./InternalNotesTabContentComponent.vue?vue&type=template&id=6dcb9440&scoped=true&"
import script from "./InternalNotesTabContentComponent.vue?vue&type=script&lang=js&"
export * from "./InternalNotesTabContentComponent.vue?vue&type=script&lang=js&"
import style0 from "./InternalNotesTabContentComponent.vue?vue&type=style&index=0&id=6dcb9440&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dcb9440",
  null
  
)

export default component.exports